export default class Collapsible {
  constructor(selector = '.navbar-collapse') {
      this.screenSizeSm = 767;
      this.init();
  }

  disableScrollingContent() {
      const that = this;
      if (window.innerWidth > this.screenSizeSm) {
          $('body').on('shown.bs.collapse', this.selector, function() {
              $('body').addClass('not-scrollable');
          });
          $('body').on('hidden.bs.collapse', this.selector, function() {
              $('body').removeClass('not-scrollable');
          });
      }

  }

  init() {
      this.disableScrollingContent();
  }
}
